export default {
    parts: ['container', 'message', 'progress', 'signInMessage'],
    baseStyle: (props) => ({
        container: {
            mb: props?.isMiniCart ? 8 : '57px',
            mt: props?.isMiniCart ? 2 : 0
        },
        message: {
            textStyle: 'bodySmRegular',
            mb: 1
        },
        progress: {
            colorScheme: 'brand',
            height: 1.5,
            size: 'sm'
        },
        signInMessage: {
            mt: 2,
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textSecondary'
        }
    })
}
